<template>
  <BaseModal name="beat-tape-items" :width="'100%'" :max-width="900" :height="'auto'" :adaptive="true" :scrollable="true" @before-open="onOpen">
    <BaseModalHeader :class="['tw-mb-4']">
      {{ name }}
    </BaseModalHeader>
    <order-confirmation-items  v-for="item in beatTapeItems" :beat="item" :item="item" :contract-download-url="item.contractDownloadUrl || item.contract_download_url" :license="item.license"
      :key="item.itemId"></order-confirmation-items>

  </BaseModal>
</template>
<script>
import orderConfirmationItems from '../routes/order-confirmation-items.vue'
import Configure from "./../../mixins/configure"
import SecondaryModal from "./../../mixins/secondary-modal"

import BaseModal from "../base/base-modal.vue";
import BaseModalHeader from "../base/base-modal-header";
import RowBeatTapeContainer from '../rowbeattapecontainer.vue'
import BeatRowHeader from './../beatrowheader.vue'
import BeatTape from "../../models/beat-tapes";
import Beat from "../../models/beat";
import BeatTapesRepository from "./../../mixins/beat-tapes-repository";
import Playlist from './../../classes/playlist'

export default {
  components: { BaseModalHeader, BaseModal, RowBeatTapeContainer, BeatRowHeader, orderConfirmationItems },
  data () {
    return {
      beatTape: null,
      name: null,
      id: null,
      page: null,
      items: null,
    }
  },
  mixins: [BeatTapesRepository, SecondaryModal, Configure],
  methods: {
    onOpen (event) {
      this.name = event.params.name
      this.id = event.params.id
      this.items = event.params.items
      this.getBeatTape(this.id)
    },
    getBeatTape (id) {
      this.$store.commit('toggleLoading')
      const self = this
      this.getUserBeatTapeItems(id)
        .then((item) => {
          this.beatTape = new BeatTape(item.data.item);
          this.$store.state.playlistManager.setPagePlaylist(new Playlist(this.beatTape, this.page ? this.page.name : '', this.pageId))
          this.$store.commit("singleMusicPageName", { name: this.beatTape.name })
        })
        .catch((e) => {
          console.error(e)
          this.$router.push({ path: "/" });
        })
        .finally(() => {
          this.$store.commit('toggleLoading')
        });
    }
  },
  computed: {
    beatTapeItems () {
      if (!this.beatTape) return
      const itemsWithLinks = this.beatTape.items.map(item => {

        let extension = this.items.find(ext => {
          return ext.id === item.id;
        });

        if (extension) {
          return Object.assign(item, { download_links: extension});
        }
      });
      this.beatTape.items = itemsWithLinks
      return Beat.makeArray(this.beatTape.items.map(item => ({ ...item.id, ...item.download_links, ...item.music_item, license: item.license })))
    }
  }
};
</script>
